import { EInternalPackageType, IBuyPackageData } from '../../../../../PayPackageMicrofrontend';
import { IRecommendedPackage } from '../../../../types/reducers/recommendedPackages';
import { mapGift } from './mapGift';

export const mapBuyPackageData = (recommendedPackage: IRecommendedPackage): IBuyPackageData => {
  const {
    totalAuctionPoints,
    autoProlong,
    categoriesView,
    discountPercent,
    durationInDays,
    activationDate,
    endDate,
    marketingPrice,
    packageId,
    polygonIds,
    price,
    regionNames,
    services,
    type,
    autoProlongAvailable,
    gifts,
    widgetSource,
  } = recommendedPackage;

  return {
    internalType: EInternalPackageType.SmartPackage,
    packageId,
    type,
    services,
    gifts: gifts.map(mapGift),
    regionNames,
    polygonIds,
    categoriesView,
    durationInDays,
    activationDate,
    endDate,
    marketingPrice,
    price,
    cashback: null,
    cashbackPercent: null,
    auctionPoints: null,
    totalAuctionPoints,
    discountPercent,
    autoProlong,
    autoProlongAvailable,
    widgetSource,
  };
};
